<template lang="pug">
  kkz-table
</template>

<script>
import KkzTable from './table/KKZTable'

export default {
  name: 'KKZReports',

  components: {
    KkzTable
  }
}
</script>
